package org.tlsys.api

import org.tlsys.AutoLoadAsyncListIterator
import org.tlsys.async2
import org.tlsys.json.jdto

fun GroupService.getGroupsIterator(minForLoad: Int, maxPart: Int) = AutoLoadAsyncListIterator(minFull = minForLoad, max = maxPart, loader = { max, offset ->
    async2 { getGroups(offset = offset.toInt().jdto, max = max.jdto).await() }
})